import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=7b8efce7&scoped=true&"
import script from "./InformationCard.vue?vue&type=script&lang=ts&"
export * from "./InformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=7b8efce7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8efce7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
